import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Stack } from '@spark-web/stack';
import { useTheme } from '@spark-web/theme';
import { FC } from 'react';

import { PARTNER_ACTION_CARD } from '~/constants';
import { MarketplacePartner } from '~/types/marketplace';

type PartnerActionCardProps = {
  partner?: MarketplacePartner;
};

export const PartnerActionCard: FC<PartnerActionCardProps> = ({ partner }) => {
  const theme = useTheme();

  const action = partner ? PARTNER_ACTION_CARD[partner] : null;

  return (
    <Box
      display="flex"
      padding="large"
      paddingBottom="xxlarge"
      borderRadius="medium"
      borderWidth="large"
      background="neutral"
      css={css({
        [`@media (min-width: ${theme.breakpoint.tablet}px)`]: {
          gridColumn: 'span 2',
        },
      })}
    >
      <Box display="flex" flexDirection="column" gap="medium">
        <Box>
          <img src={action?.icon} alt={`${action?.title} icon`} />
        </Box>
        <Stack gap="xlarge">
          {action?.title}
          {action?.description}
        </Stack>
      </Box>
    </Box>
  );
};
